/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel, PublicClientApplication } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

export const msalConfig = {
    auth: {


        //  clientId: "7e56a65a-18c2-4d74-844f-7d13aa328f5c",
        clientId: "4ba370c0-f72b-450b-a07b-09f6f49785ab",
        authority: "https://login.microsoftonline.com/2ff06a03-1c24-40f5-9d3b-854d93aaed7f",

        // redirectUri: 'https://ficheproduit.gucci.com/mockup/',
        //   postLogoutRedirectUri: "https://ficheproduit.gucci.com/mockup/"
        redirectUri: 'https://digitalpassport.gucci.com/',
        postLogoutRedirectUri: "https://digitalpassport.gucci.com/"
        // redirectUri: 'http://localhost:3000',
        // postLogoutRedirectUri: "http://localhost:3000"

    },
    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        return;
                    case LogLevel.Info:
                        return;
                    case LogLevel.Verbose:
                        return;
                    case LogLevel.Warning:
                        return;
                    default:
                        return;
                }
            }
        }
    }
};



export const msalInstance = new PublicClientApplication(msalConfig)

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["User.Read"]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "Enter_the_Graph_Endpoint_Herev1.0/me"
};
